export default {
  local: "français",
  interactivity: {
    chapters: "Chapitres",
    chapter: "Chapitre",
    Poll: "Sondage",
    yes: "Oui",
    no: "Non",
    quiz: "Questionnaire",
    dont_know: "Je ne sais pas",
    question: "Question",
    sondage: "Sondage",
    chaptersList: "Liste des chapitres",
    attachment: "Fichiers joints",
    downloadAll: "Télécharger tout",
    options: "Choix",
    prevSlide: "Diapositive précédente",
    nextSlide: "Diapositive suivante",
    viewFile: "Voir fichier",
    viewVideo: "Consulter la vidéo",
    linkNav: "Naviguer à travers le lien de la page",
  },
  language: {
    fr: "Français",
    en: "Anglais",
    es: "Espagnol",
    it: "Italien",
    zh: "Chinois",
    ru: "Russe",
    ja: "Japonais",
    pt: "Portugais",
    ar: "Arabe",
    hi: "Hindi",
    bn: "Bengali",
    de: "Allemand",
    fl: "FL - original"
  },
  player: {
    in_progress: "En cours",
    Title: "En cours",
    playVid: "Lire la vidéo",
    autoplay: "autoplay",
    audio: "Audio",
    auto: "Auto",
    buffered: "Tamponné",
    captions: "Captions",
    currentTime: "Temps actuel",
    slides: "Diapositives",
    duration: "Durée",
    enabled: "Activé",
    enterFullscreen: "Entrer en plein écran",
    enterPiP: "Miniplayer",
    exitFullscreen: "Quitter le plein écran",
    fullscreen: "Plein écran",
    live: "Direct",
    loop: "Boucle",
    mute: "Mute",
    none: "Aucun",
    normal: "Normal",
    off: "Off",
    pip: "Picture-in-Picture",
    play: "Lecture",
    pause: "Pause",
    replay: "Relecture",
    playback: "lecture",
    playbackQuality: "Qualité de lecture",
    playbackRate: "Taux de lecture",
    played: "Joué",
    scrubberLabel: "{currentTime} de {duration}",
    adjustVol: "Régler le volume",
    advance: "Avance",
    fastBackward: "Recul rapide",
    subtitleSetting: "Paramètres des sous-titres",
    offlineVideo: "La vidéo est hors ligne",
    liveVideoWillStart: "Le direct va démarrer le {date} à {hour}.",
    liveVideoIsStarting: "Le direct va commencer dans quelques instants...",
    liveVideoFinished: "Le direct est terminé.",
    liveVideoAir: "Le direct va bientôt commencer.",
    srcprocessed: "La source vidéo est en cours de traitement",
    sourceVide: "Source vide",
    forbiddenMedia: "Cette média est inaccessible.",
    privatevd: "Cette vidéo est privée",
    videoPause: "Suspendre la vidéo",
    next: "Suivant",
    previous: "Précédent",
  },
  modals: {
    moreInfo: "Plus d'infos",
    about: "À propos",
    quality: "Qualité",
    rate: "Vitesse",
    keyboardShortcuts: "Raccourcis clavier",
    showListOfShortcuts: "Afficher la liste des raccourcis clavier",
    Closeallmodals: "Fermer tous les modals",
    default: "Défaut",
    disableCaptions: "Sous-titres transcrits désactivés",
    disabled: "Désactiver",
    enableCaptions: "Activer les sous-titres/captions",
    functions: "Fonctions",
    shortcuts: "Raccourcis",
  },
  buttons: {
    menu: "Menu",
    send: "Envoyer",
    stop: "Arrêter",
    Continue: "Continuer",
    close: "Fermer",
    seekBackward: "Reculer de",
    seekForward: "Avancer de",
    settings: "Paramètres",
    subtitlesOrCc: "Sous-titres/CC",
    extractVideo: "Extraire",

    liveSubtitlesOrCc: "Sous-titres en direct",
    unmute: "Démutez",
    volume: "Volume",
    confirm: "Confirmer",
    next: "Suivant",
    download: "Télécharger",
    disableSubtitles: "sous-titres transcrits désactivés",
    share: "Partager",
    AD: "Description audio",
    rewind: "Rembobiner",
    ignore: "Ignorer",
    valid: "Valider",
    downloadTranscript: "Télécharger la transcription",
    video: "Télécharger extrait vidéo",
    audio: "Télécharger extrait audio",
  },
  AllTraslation: {
    exitPiP: "Développez",
    searchChapter: "Chercher un chapitre",
    globalInfo: "Informations générales",
    socialMedia: "RÉSEAUX SOCIAUX",
    exportVideo: "Exporter la vidéo",
    sendWithMail: "Envoyer par mail",
    shareOn: "Partager sur",
    permalink: "Permalien",
    copy: "Copier",
    embedCode: "Code Embed",
    color: "Couleur",
    startAt: "Démarrer à",
    yourEmail: "Votre email",
    receiverEmail: "Email du destinataire",
    message: "Message",
    emailExample: "example@example.com",
    writeYourMsg: "écrivez votre message ici...",
    spaceBar: "Espace",
    or: "ou",
    seconds: "Secondes",
    scrubber: "Épurateur",
    seekTotal: "Chercher le total",
    video: "Vidéo",
    viewport: "Fenêtre",
    resolution: "Résolution actuelle",
    codec: "Codec",
    host: "Hôte",
    speed: "Vitesse de connexion",
    repeat: "Répéter",
    statistics: "Statistiques",
    powered: "Alimenté par",
    continue: "Continuer",
    authentication: "Authentification",
    textAuth: "Vous devez saisir le mot de passe pour voir ce vidéo",
    NotfoundPage: "Média non trouvée",
    NotfoundPageDesc: "Le média que vous tentez d’afficher n’existe pas",
    AccessDenied: "Accès interdit",
    AccessDeniedDesc: "Le serveur refuse d'exécuter cette requête",
    AuthRequired: "Authentification requise",
    NeedAuth:
      "Veuillez vous authentifier sur la plateforme pour continuer la vidéo",
    shuffle: "mélanger",
    playlist: "Playliste",
    searchPlaylist: "Recherche",
    viewPDF: "Consulter le pdf",
    searchTranscript: "Saisir votre texte",
  },
};
